import {memo} from 'react';

import {PriceLabel} from '~/shared/components/PriceLabels';

import {Col, InnerRow, Line, LineTitle} from './shared.style';

type TwoLinesPaymentProps = {
  title: string;
  data: {
    rowTitle: string;
    price?: number;
    text?: string | number;
  }[];
};
const TwoLinesPayment = ({title, data}: TwoLinesPaymentProps) => (
  <Line paddingTop borderTop>
    <LineTitle>{title}</LineTitle>
    <Col>
      {data.map(({rowTitle, price, text}) => (
        <InnerRow key={rowTitle}>
          <div>{rowTitle}</div>
          {price && <PriceLabel price={price} />}
          {text && <div>{text}</div>}
        </InnerRow>
      ))}
    </Col>
  </Line>
);
export default memo(TwoLinesPayment);
